<template>
	<div class="flextable table-actions">
		<div class="flextable-item flextable-primary">
			<div class="btn-toolbar-item input-with-icon">
				<slot name="filter"></slot>
				<input v-if="!hideSearch" type="text" class="form-control input-block" :placeholder="placeholder" v-model="search" @input="searchChanged">
				<span v-if="!hideSearch" class="icon icon-magnifying-glass"></span>				
			</div>
		</div>
		<div class="flextable-item">
			<div class="btn-group">
				<slot name="before"></slot>
				<button v-if="!hideEdit" type="button" class="btn btn-outline-primary" :disabled="!editEnabled" @click="$emit('edit-click')">
					<span class="icon icon-pencil"></span>
				</button>
				<button v-if="!hideDelete" type="button" class="btn btn-outline-primary" :disabled="!deleteEnabled" @click="$emit('delete-click')">
					<span class="icon icon-erase"></span>
				</button>
				<slot name="after"></slot>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'TableActions',
		props: ['placeholder', 'hideSearch', 'hideEdit', 'hideDelete', 'editEnabled', 'deleteEnabled'],
		data() {
			return {
				search:''
			}
		},
		methods: {
			searchChanged: debounce(function() {
				this.$emit('search-changed', this.search);
			}, 250)
		}
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
</script>


// WEBPACK FOOTER //
// src/components/TableActions.vue